<ion-app>
  <app-navigation-menu></app-navigation-menu>
  <ion-router-outlet id="main-content"></ion-router-outlet>
</ion-app>
